import classNames from "classnames";
import { Immutable } from "immer";
import React, { useEffect, useState } from "react";

type IProps = Immutable<{
    isMobileNav: boolean;
}> & {
    closeModal: (event: React.MouseEvent<HTMLElement>) => void;
};

const DropdownCloseButton = (props: IProps): React.ReactNode => {
    const [initCloseIconAni, setInitCloseIconAni] = useState(false);

    useEffect(() => {
        setInitCloseIconAni(true);
    }, []);

    const burgerIconClassName = classNames({
        "header__dropdown-close": true,
        "header__dropdown-close--active": initCloseIconAni,
    });

    return (
        <button
            onClick={(e) => {
                props.closeModal(e);
            }}
            className={burgerIconClassName}
        >
            <span className="burger-icon" aria-hidden="true"></span>
            {/* TODO(i18n): Wrap user-facing string in t tagged template: {t`Close`} */}
            <span className="ada-screenreader-only">Close</span>
        </button>
    );
};

export default DropdownCloseButton;
